/**
 * Default core settings schema.
 * Generates the singleton form at /admin/settings.
 */
export function defaultSettingsSchema(): string {
  return JSON.stringify(
    {
      name: 'settings',
      type: 'single',
      label: 'Settings',
      description: 'General Settings',
      icon: 'Settings',
      fields: [
        {
          type: 'section',
          name: 'siteSettings',
          label: 'Dashboard Settings',
          fields: [
            {
              name: 'title',
              type: 'string',
              label: 'Application Name',
              hint: 'Displayed in the sidebar and throughout the dashboard',
              default: 'BetterStart'
            },
            { name: 'dashboardLogo', type: 'image', label: 'Logo' }
          ]
        },
        {
          type: 'section',
          name: 'developer',
          label: 'Developers',
          fields: [
            {
              name: 'devMode',
              type: 'boolean',
              label: 'Dev Mode',
              hint: 'Show generated integration snippets and schema details for developers',
              default: true
            }
          ]
        },
        {
          type: 'section',
          name: 'auditLog',
          label: 'Audit Log',
          fields: [
            {
              name: 'auditRetentionEnabled',
              type: 'boolean',
              label: 'Enable Retention Cleanup',
              hint: 'Allow admins to permanently delete audit rows older than the retention window',
              default: false
            },
            {
              name: 'auditRetentionDays',
              type: 'number',
              label: 'Retention Days',
              hint: 'Rows older than this many days are deleted when cleanup is run. Leave empty to keep audit rows forever.'
            }
          ]
        }
      ]
    },
    null,
    2
  )
}
